export default __webpack_public_path__ + "static/media/bridging-the-gap.0cfbfd95.png";